import { render, staticRenderFns } from "./EditLabels.vue?vue&type=template&id=8f3e991c&"
import script from "./EditLabels.vue?vue&type=script&lang=js&"
export * from "./EditLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports